const links = {
  facebook: 'https://www.facebook.com/creditasbr',
  instagram: 'https://www.instagram.com/creditasbr/',
  youtube: 'https://www.youtube.com/channel/UCt-q8pULaA9Fme4cVXcUAJw',
  linkedin: 'https://www.linkedin.com/company/creditasbr',
  twitter: 'https://twitter.com/Creditas_Br',
}

export { links }
